<p><strong>Pro Tip:</strong> Track your application performance.</p>
<a
  uiSref="project-performance"
  (click)="dismissCallout()"
  class="btn btn--success btn--default"
>
  Set up Performance Monitoring
</a>
